import axios from '../services/axios'

const fetcher = async (args) => {
  const [url, config = {}] = Array.isArray(args) ? args : [args]

  return axios
    .get(url, config)
    .then((response) =>
      Object.keys(response?.data).length === 1
        ? response.data.data
        : response?.data
    )
}
const options = {
  fetcher,
}

export default options
